function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Feature, Map } from "ol";
import { View } from "./view_ex";
import { Group, Tile, Vector as layerVector } from "ol/layer";
import { Vector as sourceVector } from "ol/source";
import { Circle, LineString, Point, Polygon } from "ol/geom";
import { Fill, Icon, Stroke, Style } from "ol/style";
import { MapboxMap } from "./source/mapboxmap";
import { GoogleMap } from "./source/googlemap";
import { NowMap } from "./source/nowmap";
import { MapboxLayer } from "./layer_mapbox";
import { normalizeArg } from "./functions";
import bluedot from "../parts/bluedot.png";
import bluedot_transparent from "../parts/bluedot_transparent.png";
import bluedot_small from "../parts/bluedot_small.png";
import defaultpin from "../parts/defaultpin.png";
var gpsStyle = new Style({
  image: new Icon({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    src: bluedot
  })
});
var gpsHideStyle = new Style({
  image: new Icon({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    src: bluedot_transparent
  })
});
var gpsSubStyle = new Style({
  image: new Icon({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    src: bluedot_small
  })
});
var accCircleStyle = new Style({
  fill: new Fill({
    color: [128, 128, 256, 0.2]
  }),
  stroke: new Stroke({
    color: [128, 128, 256, 1.0],
    width: 3
  })
});
var markerDefaultStyle = new Style({
  image: new Icon({
    anchor: [0.5, 1.0],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    src: defaultpin
  })
});
export var MaplatMap = /*#__PURE__*/function (_Map) {
  _inherits(MaplatMap, _Map);
  var _super = _createSuper(MaplatMap);
  function MaplatMap(optOptions) {
    var _this;
    _classCallCheck(this, MaplatMap);
    optOptions = normalizeArg(optOptions || {});
    var vectorLayer = new layerVector({
      source: new sourceVector({
        wrapX: false
      })
    });
    vectorLayer.set("name", "gps");
    var markerLayer = new layerVector({
      source: new sourceVector({
        wrapX: false
      })
    });
    markerLayer.set("name", "marker");
    var featureLayer = new layerVector({
      source: new sourceVector({
        wrapX: false
      })
    });
    featureLayer.set("name", "feature");
    var envelopeLayer = new layerVector({
      source: new sourceVector({
        wrapX: false
      })
    });
    envelopeLayer.set("name", "envelope");
    var baseLayer = MaplatMap.spawnLayer(null, optOptions.source, optOptions.target);
    var overlayLayer = new Group();
    overlayLayer.set("name", "overlay");
    var controls = optOptions.controls ? optOptions.controls : [];
    var options = {
      controls: controls,
      layers: [baseLayer, overlayLayer, envelopeLayer, featureLayer, vectorLayer, markerLayer],
      target: optOptions.div,
      view: new View({
        center: optOptions.defaultCenter || [0, 0],
        zoom: optOptions.defaultZoom || 2,
        rotation: optOptions.defaultRotation || 0,
        multiWorld: true
      })
    };
    if (optOptions.interactions) {
      options.interactions = optOptions.interactions;
    }
    _this = _super.call(this, options);
    _this.__first_gps_request = true;
    _this.fakeGps = optOptions.fakeGps;
    _this.fakeRadius = optOptions.fakeRadius;
    _this.homePosition = optOptions.homePosition;
    _this.northUp = optOptions.northUp;
    _this.tapDuration = optOptions.tapDuration;
    _this.homeMarginPixels = optOptions.homeMarginPixels;
    _this.tapUIVanish = optOptions.tapUIVanish;
    _this.alwaysGpsOn = optOptions.alwaysGpsOn || false;
    var view = _this.getView();
    _this.__ignore_first_move = true;
    var movestart = function movestart() {
      if (!_this.__ignore_first_move) _this.dispatchEvent("movestart");
      _this.__ignore_first_move = false;
      view.un("propertychange", movestart);
    };
    view.on("propertychange", movestart);
    _this.on("moveend", function () {
      view.on("propertychange", movestart);
    });
    return _this;
  }
  _createClass(MaplatMap, [{
    key: "getLayer",
    value: function getLayer() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "base";
      var recur = function recur(layers) {
        var filtered = layers.getArray().map(function (layer) {
          if (layer.get("name") == name) return layer;
          if (layer.getLayers) return recur(layer.getLayers());
          return;
        }).filter(function (layer) {
          return layer;
        });
        if (filtered.length == 0) return;
        return filtered[0];
      };
      return recur(this.getLayers());
    }
  }, {
    key: "getSource",
    value: function getSource() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "base";
      var layer = this.getLayer(name);
      if (!layer) return;
      return layer.getSource();
    }
  }, {
    key: "setFeature",
    value: function setFeature(data, style, layer) {
      var src = this.getSource(layer);
      var feature = new Feature(data);
      if (style) {
        feature.setStyle(style);
      }
      src.addFeature(feature);
      return feature;
    }
  }, {
    key: "removeFeature",
    value: function removeFeature(feature, layer) {
      var src = this.getSource(layer);
      src.removeFeature(feature);
    }
  }, {
    key: "resetFeature",
    value: function resetFeature(layer) {
      var src = this.getSource(layer);
      src.clear();
    }
  }, {
    key: "setGPSPosition",
    value: function setGPSPosition(pos) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var style = type == "sub" ? gpsSubStyle : type == "hide" ? gpsHideStyle : gpsStyle;
      if (type != "sub") {
        this.resetFeature("gps");
      }
      if (pos) {
        this.setFeature({
          geometry: new Point(pos.xy)
        }, style, "gps");
        if (!type) {
          this.setFeature({
            geometry: new Circle(pos.xy, pos.rad)
          }, accCircleStyle, "gps");
        }
      }
    }
  }, {
    key: "setMarker",
    value: function setMarker(xy, data, markerStyle, layer) {
      if (!layer) layer = "marker";
      data["geometry"] = new Point(xy);
      if (!markerStyle) markerStyle = markerDefaultStyle;else if (typeof markerStyle == "string") {
        markerStyle = new Style({
          image: new Icon({
            anchor: [0.5, 1.0],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: markerStyle
          })
        });
      } else if (!(markerStyle instanceof Style)) {
        markerStyle = new Style({
          image: new Icon(markerStyle)
        });
      }
      return this.setFeature(data, markerStyle, layer);
    }
  }, {
    key: "resetMarker",
    value: function resetMarker(layer) {
      if (!layer) layer = "marker";
      this.resetFeature(layer);
    }
  }, {
    key: "setLine",
    value: function setLine(xys, stroke, layer) {
      return this.setVector(xys, "Line", stroke ? {
        stroke: stroke
      } : null, layer);
    }
  }, {
    key: "setVector",
    value: function setVector(coords) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Line";
      var style = arguments.length > 2 ? arguments[2] : undefined;
      var layer = arguments.length > 3 ? arguments[3] : undefined;
      if (!layer) layer = "feature";
      var option = {};
      if (style.stroke != null) option.stroke = new Stroke(style.stroke);
      if (style.fill != null) option.fill = new Fill(style.fill);
      var styleObj = new Style(option);
      var geometry = type === "Line" ? new LineString(coords) : new Polygon(coords);
      return this.setFeature({
        geometry: geometry,
        name: type
      }, styleObj, layer);
    }
  }, {
    key: "resetLine",
    value: function resetLine(layer) {
      this.resetVector(layer);
    }
  }, {
    key: "resetVector",
    value: function resetVector(layer) {
      if (!layer) layer = "feature";
      this.resetFeature(layer);
    }
  }, {
    key: "setEnvelope",
    value: function setEnvelope(xys, stroke, layer) {
      if (!layer) layer = "envelope";
      return this.setLine(xys, stroke, layer);
    }
  }, {
    key: "removeEnvelope",
    value: function removeEnvelope(feature, layer) {
      if (!layer) layer = "envelope";
      this.removeFeature(feature, layer);
    }
  }, {
    key: "resetEnvelope",
    value: function resetEnvelope(layer) {
      if (!layer) layer = "envelope";
      this.resetFeature(layer);
    }
  }, {
    key: "setFillEnvelope",
    value: function setFillEnvelope(xys, stroke, fill, layer) {
      if (!layer) layer = "envelope";
      var style;
      if (stroke != null || fill != null) {
        var option = {};
        if (stroke != null) option.stroke = new Stroke(stroke);
        if (fill != null) option.fill = new Fill(fill);
        style = new Style(option);
      }
      return this.setFeature({
        geometry: new Polygon([xys])
      }, style, layer);
    }
  }, {
    key: "exchangeSource",
    value: function exchangeSource() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var layers = this.getLayers();
      var prevLayer = layers.item(0);
      var layer = MaplatMap.spawnLayer(prevLayer, source, this.getTarget());
      if (layer != prevLayer) layers.setAt(0, layer);
      if (source) {
        source.setMap(this);
      }
    }
  }, {
    key: "setLayer",
    value: function setLayer() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      var layers = this.getLayer("overlay").getLayers();
      layers.clear();
      if (source) {
        var layer = new Tile({
          source: source
        });
        layers.push(layer);
      }
    }
  }, {
    key: "setTransparency",
    value: function setTransparency(percentage) {
      var opacity = (100 - percentage) / 100;
      var source = this.getSource();
      if (source instanceof NowMap || source instanceof GoogleMap) {
        this.getLayers().item(0).setOpacity(1);
        this.getLayers().item(1).setOpacity(opacity);
      } else {
        this.getLayers().item(0).setOpacity(opacity);
      }
    }
  }, {
    key: "setGPSMarker",
    value: function setGPSMarker(position, ignoreMove) {
      var source = this.getLayers().item(0).getSource();
      source.setGPSMarker(position, ignoreMove);
    }
  }], [{
    key: "spawnLayer",
    value: function spawnLayer(layer, source, container) {
      if (source instanceof MapboxMap || !(layer instanceof Tile)) {
        if (source instanceof MapboxMap) {
          layer = new MapboxLayer({
            style: source.style,
            accessToken: source.accessToken,
            container: container,
            source: source
          });
        } else {
          layer = new Tile({
            source: source
          });
        }
        layer.set("name", "base");
      } else {
        layer.setSource(source);
      }
      return layer;
    }
  }]);
  return MaplatMap;
}(Map);